import { ComponentStyleConfig } from "@chakra-ui/react";

export const ReiHeading: ComponentStyleConfig = {
  baseStyle: {
    fontFamily: "heading",
    fontWeight: 700,
    letterSpacing: "-0.02em",
    color: "ink.DEFAULT",
  },
};
